export default {
    gutterBottom: {
        marginBottom: 2
    }
};
